
// export const baseUrl = 'https://reslibapi-test.x-lingtong.com';
// 测试：https://res-test.x-lingtong.cn/api    正式：https://res.x-lingtong.cn/api
// export const baseUrl = 'https://res.x-lingtong.com/api';
// export const baseUrl = 'https://reslibapi-test.x-lingtong.com/api';

export const baseUrl = 'https://res.x-lingtong.com/api';
export const requestTimeOut = 30000
export const signKey = 'sChGwktY11eId678BN4F3HfVJg7Tyl86';